export const siteData = {
  name: "黄油游戏官方指南",
  tagline: "玩转黄油游戏，从这里开始",
  description: "黄油游戏官方指南致力于为玩家提供最全面的黄油游戏攻略、推荐与玩法教程，帮助每一位玩家找到属于自己的沉浸式游戏体验。",
  email: "contact@buttergameguide.com",
  address: "中国北京市朝阳区游戏产业园区A座",
  phone: "+86 400-888-0000",
  socialLinks: {
    weibo: "https://weibo.com/buttergame",
    bilibili: "https://bilibili.com/buttergame",
    wechat: "buttergame_guide",
  },
  stats: {
    articles: 230,
    readers: 50000,
    categories: 5,
    authors: 15,
  },
  brandStory: {
    title: "品牌故事",
    content: `黄油游戏官方指南成立于2020年，由一群热爱黄油游戏的资深玩家共同创建。我们的使命是为黄油游戏玩家提供最专业、最全面的黄油游戏攻略与推荐服务。

经过多年的发展，黄油游戏官方指南已经成长为黄油游戏领域最具影响力的中文内容平台之一。我们拥有超过230篇原创黄油游戏攻略文章，覆盖黄油游戏新手入门、热门推荐、进阶攻略、玩法教程等多个领域。

我们的团队由15位黄油游戏资深玩家和内容创作者组成，每位成员都对黄油游戏有着深刻的理解和独特的见解。我们坚持原创内容创作，力求每一篇黄油游戏攻略都具有实用价值和参考意义。`,
    milestones: [
      { year: "2020", event: "黄油游戏官方指南正式上线" },
      { year: "2021", event: "黄油游戏攻略文章突破100篇" },
      { year: "2022", event: "黄油游戏阅读用户突破1万人" },
      { year: "2023", event: "黄油游戏内容全面改版升级" },
      { year: "2024", event: "黄油游戏攻略文章突破200篇" },
      { year: "2025", event: "黄油游戏阅读用户突破5万人" },
      { year: "2026", event: "黄油游戏分类体系全面优化" },
    ],
  },
  reputation: {
    title: "口碑见证",
    testimonials: [
      {
        name: "小明",
        role: "黄油游戏玩家",
        content: "黄油游戏官方指南是我入坑黄油游戏的第一站，攻略内容详细易懂，推荐作品质量很高！通过黄油游戏官方指南，我找到了好多喜欢的黄油游戏。",
        rating: 5,
      },
      {
        name: "游戏达人阿杰",
        role: "黄油游戏资深玩家",
        content: "黄油游戏官方指南的进阶攻略写得太好了，很多黄油游戏技巧都是在这里学到的。黄油游戏的隐藏要素收集指南帮我省了不少时间。",
        rating: 5,
      },
      {
        name: "小蝶",
        role: "黄油游戏爱好者",
        content: "黄油游戏热门推荐栏目是我每周必看的！通过黄油游戏官方指南发现了不少小众黄油游戏精品，黄油游戏的世界比我想象的更精彩。",
        rating: 5,
      },
      {
        name: "老王游戏",
        role: "黄油游戏UP主",
        content: "作为黄油游戏内容创作者，黄油游戏官方指南是我重要的参考资料。黄油游戏的攻略质量一直很稳定，黄油游戏社区的互动氛围也很棒。",
        rating: 5,
      },
    ],
  },
  faq: [
    {
      question: "黄油游戏适合什么样的玩家？",
      answer: "黄油游戏适合喜欢创意互动娱乐、重视游戏剧情和角色发展的玩家。无论你是黄油游戏新手还是资深玩家，都能在黄油游戏中找到适合自己的作品和玩法。黄油游戏的魅力在于其丰富的品类和多样的体验。",
    },
    {
      question: "如何选择合适的黄油游戏入门作品？",
      answer: "对于黄油游戏新手，建议从操作简单、剧情引导性强的黄油游戏作品开始。可以参考我们网站上的黄油游戏新手入门栏目和黄油游戏热门推荐榜单，选择评价高、上手容易的黄油游戏作品。",
    },
    {
      question: "黄油游戏的更新频率如何？",
      answer: "不同黄油游戏的更新频率有所差异。热门黄油游戏通常每1-3个月会推出一次内容更新，包括新剧情、新角色和新活动。建议关注黄油游戏的官方公告和我们网站的黄油游戏攻略栏目获取最新资讯。",
    },
    {
      question: "黄油游戏支持多平台吗？",
      answer: "大多数黄油游戏支持Windows平台，越来越多的黄油游戏也开始支持Mac、移动端和主机平台。具体支持情况请查看各黄油游戏的官方说明。我们网站的黄油游戏资源栏目也会标注各作品支持的平台信息。",
    },
    {
      question: "黄油游戏的付费模式是怎样的？",
      answer: "黄油游戏的付费模式多种多样，包括买断制、章节付费制和免费游玩加内购等。建议在购买黄油游戏前了解清楚付费模式，选择最适合自己的黄油游戏消费方式。",
    },
  ],
};